import React, { Fragment } from 'react';

type Props = { message: string, onRetry: () => void };

const ErrorMessage = ({ message, onRetry }: Props) => (
  <Fragment>
    {message}
    {onRetry && <button onClick={onRetry}> Please Retry!</button>}
  </Fragment>
);

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.jsx